import axios from 'axios';
import { GITHUB_CONFIG_ERROR_CODES, type ApiErrorBody } from '@aiai/shared';

/** A classified external-token/config problem, ready to render as a notice. */
export interface ConfigError {
  code: string;
  message: string;
  /** The GitHub permission the token needs, when it's a permission problem. */
  permission?: string;
}

/**
 * If `err` is an API error tagged with a known GitHub config `code`, return a
 * structured ConfigError; otherwise null (callers fall back to a generic error).
 * This is how the UI tells "your GitHub token needs fixing" apart from a real
 * failure — the API guarantees these are never HTTP 401.
 */
export function configError(err: unknown): ConfigError | null {
  if (!axios.isAxiosError(err)) return null;
  const data = err.response?.data as ApiErrorBody | undefined;
  const code = data?.code;
  if (!code || !(GITHUB_CONFIG_ERROR_CODES as readonly string[]).includes(code)) {
    return null;
  }
  const message = Array.isArray(data!.message)
    ? data!.message.join(', ')
    : data!.message;
  return { code, message, permission: data!.permission };
}
